import { useCookies } from "react-cookie";
import { useEffect } from "react";
import Constants from "../../utils/Constants";

// 更新日時更新
export const useProtectedRouteMaxage = function () {

  const [cookies, setCookie] = useCookies(["maxage"]);

  // 更新日時更新
  useEffect(() => {
    // 現在日付
    let date = new Date();
    // 時間内
    date.setSeconds(date.getSeconds() + Constants.SESSION_MAX_ARG);
    // 有効期限更新
    setCookie("maxage", date);
  }, [setCookie])  // // 有効日時更新
};

export default useProtectedRouteMaxage;
